import React from 'react';
import cn from 'classnames';
import Card from '../../../../../components/Card';
import IndicatorBadge from '../../common/IndicatorBadge/IndicatorBadge';
import { generateExpWithNum } from '../../../utils/generateExpWithNum';
import { declensions } from '../../../constants/declensions';
import styles from './StatusCard.module.scss';

const StatusCard = ({
  status,
  indicator = true,
  indicatorBgColor,
  className,
}) => {
  return (
    <Card className={cn(styles.root, className)}>
      {indicator && <IndicatorBadge bgColor={indicatorBgColor} />}
      <p className={styles.text}>{status.name}</p>
      <p className={cn(styles.text, styles.accent)}>
        {generateExpWithNum(status.count, declensions.flats)}
      </p>
    </Card>
  );
};

export default StatusCard;
